var domain = window.location.hostname == 'http://localhost' ? 'http://localhost:8000' : 'http://localhost:8000'
export const API_URL = domain+'/api';
export default API_URL;
